import { createAction } from "redux-actions";
import { moduleSlug } from "modules/ConfigManager/constants";

export const initConfigManagerModule = createAction(`${moduleSlug}/INITIAL_CONFIG_MANAGER_MODULE`);